import React, { Fragment } from 'react';
import moment from 'moment';
import { connect as formikConnect } from 'formik';
import { connect } from 'react-redux';
import { FormGroup, InputGroup, InputGroupAddon, Input } from 'reactstrap';

import PromoCode from '../../../../components/PromoCode';
import { ReviewYourBooking, CustomCounter } from '../../../../components';

const mapStateToProps = ({ selectedTrek: { trek } }, ownProps) => {
  const {
    number_of_days,
    start_date,
    price: { amount: unitPrice },
  } = trek;
  const {
    values: { pax },
    handleSubmit,
  } = ownProps.formik;

  return {
    pax,
    handleSubmit,
    startDate: start_date,
    unitPrice,
    numberOfDays: number_of_days,
  };
};

type Props = {
  pax: number,
  startDate: string,
  unitPrice: number,
  totalPrice: number,
  numberOfDays: number,
  handleSubmit: () => void,
};

const BookSection = ({
  pax,
  startDate = '',
  unitPrice = '',
  numberOfDays,
  totalPrice,
  handleSubmit,
}: Props) => (
  <div className="widget-panel">
    <div className="widget-wrap">
      <CustomCounter title="No. of People" />
      <FormGroup className="input-box">
        <InputGroup>
          <InputGroupAddon>
            <small>Trek Start Date</small>
          </InputGroupAddon>
        </InputGroup>
        <InputGroup>
          <InputGroupAddon addonType="prepend">
            <span className="input-group-text">
              <i className="icon icon-hg-calendar" />
            </span>
          </InputGroupAddon>
          <Input
            name="trekStartDate"
            value={moment(startDate).format('DD MMM YYYY')}
            readOnly
          />
        </InputGroup>
      </FormGroup>
      <p>
        <strong>FREE REFUND</strong>
        <br />1 Month.
      </p>
      <div>
        <hr />
        <PromoCode />
      </div>
    </div>
    <ReviewYourBooking
      startDate={startDate}
      unitPrice={unitPrice}
      numberOfDays={numberOfDays}
      pax={pax}
      totalPrice={totalPrice}
      onSubmit={handleSubmit}
      ImportantNote={<ImportantNote />}
    />
  </div>
);

export default formikConnect(connect(mapStateToProps)(BookSection));

const ImportantNote = () => (
  <Fragment>
    <li style={{ color: '#000' }}>
      <strong>IMPORTANT NOTE</strong>
    </li>
    <li style={{ color: '#000' }}>
      If there are multiple people going on this trek, it is strongly advised to book
      together to make sure you get bookings in the lodges of your choice.
    </li>
  </Fragment>
);



// WEBPACK FOOTER //
// ./src/screens/Trek/Guided/Review/BookSection.js